import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { EinvoiceDiscrepanciesReportContainerModel } from '../../../../../models/aggregates/e-invoice/my-einvoice_discrepancies_report_container.model';


@Injectable({
  providedIn: 'root'
})

export class EinvoiceDiscrepanciesReportService extends BaseApiTemplateService<EinvoiceDiscrepanciesReportContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + 'discrepancies-reports/' + BaseApiTemplateService.BACKOFFICE_EP;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + 'discrepancies-reports/' + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX+ 'discrepancies-reports/' + BaseApiTemplateService.BACKOFFICE_EP;
    this.httpClient = http;
  }

}
